<template>
  <div
    class="wrapper process-list-container"
    :class="{ 'preview-process-list-container': isPreviewSection }"
  >
    <div
      class="add-new-button-wrapper"
      v-if="hasAddNewFlowPermission && !isPreviewSection"
    >
      <div
        class="add-new-button"
        @click="createNewFlow()"
        ref="plusButton"
        v-b-tooltip.hover.top
        title="Workflow erstellen"
      >
        Neu
        <i class="fas fa-chevron-down btn" @click.stop="toggleUploadFile"></i>
      </div>
      <div
        class="dropdown-list-open"
        :class="{ 'unset-zIndex': isLoading }"
        v-if="isUploadFileVisible"
      >
        <div
          class="filter dropdown upload"
          :class="{ 'drag-over': isFileDragging }"
          @click="toggleFileUploader()"
          v-click-outside="hideFileUploader"
          @drop.prevent="handleFileDrop"
          @dragenter.prevent="isFileDragging = true"
          @dragover.prevent="isFileDragging = true"
          @dragleave.prevent="isFileDragging = false"
        >
          <i class="fas fa-upload"></i>
          <p>Aus Datei importieren</p>
          <input
            ref="uploadBtn"
            style="display: none"
            type="file"
            accept="application/json"
            @change="importFlow"
          />
        </div>
      </div>
    </div>
    <div class="action-top-bar">
      <div class="action-top-bar-left">
        <div class="menu3-bar" v-show="isZoomVisible">
          <!-- filter by key / value -->
          <span>
            <ul class="list-item">
              <li v-if="!isPreviewSection" class="item filter-option">
                <div class="key-filter">
                  <!-- Add new filter button -->
                  <div class="filter" v-click-outside="hideAddFilter">
                    <div class="filter-icon" @click="showAddFilter">
                      <img src="../assets/img/filter-icon.svg" />
                    </div>

                    <!-- Add new filter drop down-->
                    <div
                      class="filter dropdown add"
                      :class="{ 'is-key-selected': activeFilter.caption }"
                      v-if="activeFilter != null && isAddFilterVisible"
                    >
                      <div class="initial-dropdown-items">
                        <b-dropdown-item
                          v-show="!activeFilter.caption"
                          v-for="item in dataSchema"
                          :key="item.name"
                          @click="addFilterCaption(item.name)"
                        >
                          {{ formatLabel(item.label) }}
                        </b-dropdown-item>
                      </div>

                      <div v-show="activeFilter.caption">
                        <generalDropdown
                          className="filter-dropdown filter-margin-right"
                        >
                          <template v-slot:selectFilter>
                            <span class="line-clamp"
                              >{{ activeFilter.caption }}
                            </span>
                          </template>
                          <template v-slot:optionData>
                            <b-dropdown-item
                              v-for="item in dataSchema"
                              :key="item.label"
                              @click="addFilterCaption(item.name)"
                            >
                              {{ formatLabel(item.label) }}
                            </b-dropdown-item>
                          </template>
                        </generalDropdown>
                        <generalDropdown
                          className="filter-dropdown filter-margin-right"
                        >
                          <template v-slot:selectFilter>
                            <span class="line-clamp"
                              >{{ activeFilter.opperandLabel }}
                            </span>
                          </template>
                          <template v-slot:optionData>
                            <b-dropdown-item
                              v-for="operator in getOperatorOption"
                              :key="operator.label"
                              @click="
                                addFilterOpperand(
                                  operator.opperand,
                                  operator.label
                                )
                              "
                              v-show="showFilterOperator(operator)"
                            >
                              {{ operator.label }}
                            </b-dropdown-item>
                          </template>
                        </generalDropdown>
                        <input
                          v-if="
                            !activeFilter.type || activeFilter.type == 'text'
                          "
                          name="filter"
                          v-model="activeFilter.value"
                          :type="activeFilter.type"
                          class="filter-input"
                        />
                        <generalDropdown
                          ref="tagFilterDropRef"
                          uniqueReferenceId="tagFilterDropRef"
                          className="filter-dropdown checkbox-dropdown"
                          v-else-if="activeFilter.type == 'checkbox'"
                        >
                          <template v-slot:selectFilter>
                            <div class="selected-filter-checkbox-options-wrap">
                              <div
                                class="selected-filter-checkbox-item"
                                v-for="(filter, index) in activeFilter.value"
                                :key="index"
                                :style="{ backgroundColor: filter.meta.color }"
                              >
                                {{ filter.name }}
                              </div>
                            </div>
                          </template>
                          <template v-slot:optionData>
                            <div
                              class="selected-filter-options-wrap"
                              v-if="activeFilter.value.length"
                            >
                              <div
                                class="selected-filter-options"
                                v-for="(filter, index) in activeFilter.value"
                                :key="index"
                                :style="{ backgroundColor: filter.meta.color }"
                              >
                                <span> {{ filter.name }}</span>

                                <i
                                  class="fa fa-times"
                                  @click.stop="
                                    removeSelectedRadioOrCheckboxOption(index)
                                  "
                                ></i>
                              </div>
                            </div>
                            <div
                              v-for="(
                                optionValue, indx
                              ) in getActiveFilterOption"
                              :key="
                                optionValue.value + indx || optionValue + indx
                              "
                              :class="{ 'tag-item': optionValue?.meta?.color }"
                              class="dropdown-item"
                            >
                              <b-form-checkbox
                                v-model="activeFilter.value"
                                :value="optionValue"
                              >
                                <span
                                  class="tag-option-name"
                                  :style="{
                                    backgroundColor: optionValue.meta.color,
                                  }"
                                >
                                  {{ optionValue.name || optionValue }}</span
                                >
                              </b-form-checkbox>
                            </div>
                          </template>
                        </generalDropdown>
                        <generalDropdown
                          className="filter-dropdown"
                          v-else-if="activeFilter.type == 'radio'"
                        >
                          <template v-slot:selectFilter>
                            <span class="line-clamp"
                              >{{ activeFilter.valueName }}
                            </span>
                          </template>
                          <template v-slot:optionData>
                            <b-dropdown-item
                              v-for="(
                                optionValue, indx
                              ) in getActiveFilterOption"
                              :key="
                                optionValue.value + indx || optionValue + indx
                              "
                              @click="
                                addFilterValue(
                                  optionValue.value || optionValue,
                                  optionValue.name || optionValue
                                )
                              "
                              :class="{ 'tag-item': optionValue?.meta?.color }"
                            >
                              {{ optionValue.name || optionValue }}
                              <div
                                v-if="optionValue?.meta?.color"
                                class="tag-color-block"
                                :style="{
                                  backgroundColor: optionValue.meta.color,
                                }"
                              ></div>
                            </b-dropdown-item>
                          </template>
                        </generalDropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="item search-option" v-click-outside="hideSearch">
                <div :class="{ active: searchActive }" class="search">
                  <img
                    src="../assets/img/search-icon.svg"
                    class="search-icon"
                    @click="toggleSearch"
                  />
                  <input ref="search" v-model="search" />
                </div>
              </li>
              <li v-if="!isPreviewSection" class="item-mode-toggle">
                <img
                  :src="
                    require(`../assets/img/group-toggle-${
                      !isGroupFlowListOpen ? 'on' : 'off'
                    }.svg`)
                  "
                  @click="toggleGroupView"
                />
              </li>
              <template v-if="!isPreviewSection">
                <li
                  v-for="(value, key, index) in filterOptions"
                  :key="index"
                  class="item"
                  @click="setFilter(key)"
                  :class="{ active: filter == key }"
                  v-if="key !== 'requests' || processFlowRequestList.length"
                >
                  <a>{{ value.caption }}</a>
                  <span v-if="key === 'requests'" class="pending-request">{{
                    processFlowRequestList.length
                  }}</span>
                </li>
              </template>
            </ul>
          </span>
        </div>
      </div>
      <div class="action-top-bar-right">
        <NoFlows v-if="noData && !isLoading && !getFlowsLoading" />
        <div class="process-list-topbar" v-else>
          <div
            class="settings-button-wrapper"
            :class="{ 'pt-3': !hasAddNewFlowPermission }"
          >
            <div
              class="refresh"
              :class="{ rotation: isRefreshing }"
              @click="!isRefreshing && refreshTable()"
              v-b-tooltip.hover
              title="Aktualisieren"
            >
              <img src="../assets/img/refresh.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter list -->
    <div id="filter-list-main-wrap" class="filter-list-main-wrap">
      <div class="filter-item-wrapper" v-if="showFilter && !isPreviewSection">
        <div
          class="filter-item"
          v-for="filter in filters"
          :key="filter.id"
          @click="showEditFilter(filter)"
          :style="getFilterItemStyles(filter)"
        >
          <div class="d-flex align-items-center tag__wrapper">
            <span
              ><b>{{ filter.caption }}</b> :
              {{ getFilterValue(filter) }}
            </span>
            <i
              title="Löschen"
              class="fas fa-times-circle"
              @click="removeFilter(filter.id)"
            ></i>
          </div>
          <!-- Edit filter drop down-->
          <div
            v-if="
              activeFilter != null &&
              isEditFilterVisible &&
              activeFilter.id == filter.id
            "
            class="filter dropdown edit"
            v-click-outside="hideEditFilter"
          >
            <generalDropdown className="filter-dropdown filter-margin-right">
              <template v-slot:selectFilter>
                <span class="line-clamp"
                  >{{ activeFilter.opperandLabel }}
                </span>
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="operator in getOperatorOption"
                  :key="operator.label"
                  @click="addFilterOpperand(operator.opperand, operator.label)"
                  v-show="showFilterOperator(operator)"
                >
                  {{ operator.label }}
                </b-dropdown-item>
              </template>
            </generalDropdown>

            <input
              v-if="!activeFilter.type || activeFilter.type == 'text'"
              name="filter"
              v-model="activeFilter.value"
              :type="activeFilter.type"
              class="filter-input"
            />
            <generalDropdown
              className="filter-dropdown filter-margin-left"
              v-else-if="activeFilter.type == 'radio'"
            >
              <template v-slot:selectFilter>
                <span class="line-clamp">{{ activeFilter.valueName }} </span>
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="(optionValue, indx) in getActiveFilterOption"
                  :key="optionValue.value + indx || optionValue + indx"
                  @click="
                    addFilterValue(
                      optionValue.value || optionValue,
                      optionValue.name || optionValue
                    )
                  "
                  :class="{ 'tag-item': optionValue?.meta?.color }"
                >
                  {{ optionValue.name || optionValue }}
                  <div
                    v-if="optionValue?.meta?.color"
                    class="tag-color-block"
                    :style="{
                      backgroundColor: optionValue.meta.color,
                    }"
                  ></div>
                </b-dropdown-item>
              </template>
            </generalDropdown>
            <generalDropdown
              :ref="`tagEditFilterDropRef${filter.id}`"
              :uniqueReferenceId="`tagEditFilterDropRef${filter.id}`"
              className="filter-dropdown checkbox-dropdown"
              v-else-if="activeFilter.type == 'checkbox'"
            >
              <template v-slot:selectFilter>
                <div class="selected-filter-checkbox-options-wrap">
                  <div
                    class="selected-filter-checkbox-item"
                    v-for="(filter, index) in activeFilter.value"
                    :key="index"
                    :style="{ backgroundColor: filter.meta.color }"
                  >
                    {{ filter.name }}
                  </div>
                </div>
              </template>
              <template v-slot:optionData>
                <div
                  class="selected-filter-options-wrap"
                  v-if="activeFilter.value.length"
                >
                  <div
                    class="selected-filter-options"
                    v-for="(filter, index) in activeFilter.value"
                    :key="index"
                    :style="{ backgroundColor: filter.meta.color }"
                  >
                    <span> {{ filter.name }}</span>

                    <i
                      class="fa fa-times"
                      @click.stop="removeSelectedRadioOrCheckboxOption(index)"
                    ></i>
                  </div>
                </div>
                <div
                  v-for="(optionValue, indx) in getActiveFilterOption"
                  :key="optionValue.value + indx || optionValue + indx"
                  :class="{ 'tag-item': optionValue?.meta?.color }"
                  class="dropdown-item"
                >
                  <b-form-checkbox
                    v-model="activeFilter.value"
                    :value="optionValue"
                  >
                    <span
                      class="tag-option-name"
                      :style="{
                        backgroundColor: optionValue.meta.color,
                      }"
                    >
                      {{ optionValue.name || optionValue }}</span
                    >
                  </b-form-checkbox>
                </div>
              </template>
            </generalDropdown>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="(noData || !sortedProcessList.length) && !isLoading"
      class="no-data"
    >
      <div dz-preview-wrapper class="dz-no-content-message">
        <h3>Kein Workflow verfügbar</h3>
        <p v-if="hasAddNewFlowPermission">
          Klicken Sie hier, um einen neuen Workflow hinzuzufügen
        </p>
        <img
          v-if="hasAddNewFlowPermission"
          src="../assets/img/add.svg"
          class="no-data create-workflow"
          @click="createNewFlow"
        />
        <img
          v-if="!hasAddNewFlowPermission"
          src="../assets/img/nodata.svg"
          class="no-data"
        />
      </div>
    </div>

    <div
      v-if="!noData && !isLoading"
      class="process-list fancy-scroll"
      :class="{
        'full-height': !hasAddNewFlowPermission,
        'disable-scroll': addTag.isTagModalVisible,
      }"
      @scroll.passive="showScrollbar"
    >
      <div class="progress-icon dark-color center" v-show="isLoading"></div>
      <CopyEmbedModal
        v-if="copyEmbedModal.visible"
        :copyEmbedModal="copyEmbedModal"
        @closeModal="closeCopyEmbedModal"
      />
      <CommonModal
        v-if="flowRequest.isVisibleFlowConfirmation"
        header="confirm-message"
        :buttons="flowRequestActions"
        @onConfirmFlowRequest="onConfirmFlowRequest"
        @onCancelCancelFlowRequest="onCancelCancelFlowRequest"
        ><template v-slot:confirm-message>
          <div class="confirm-message-wrapper">
            <p class="confirm-message">
              {{ flowRequest.flowConfirmationMessage }}
            </p>
          </div>
        </template>
      </CommonModal>
      <div class="process-list-wrapper" v-if="isShowTableView">
        <WorkFlowListCard
          v-for="p in sortedProcessList"
          :process="p"
          :selectedFlows="selectedFlows"
          :addTag="addTag"
          :showLoadingOverlay="showLoadingOverlay"
          :copyEmbedModal="copyEmbedModal"
          :resourceType="resourceType"
          :confirmationModal="confirmationModal"
          :isShareModalVisible="isShareModalVisible"
          :flowRequest="flowRequest"
          :selectedFlow="selectedFlow"
          :filter="filter"
          :selectionMsg="selectionMsg"
          @setSelectedFlow="setSelectedFlow"
          @setResourceType="setResourceType"
          @setIsLoading="setIsLoading"
          @setShareFlowModal="setShareFlowModal"
          @onFlowSelect="onFlowSelect"
          @setAreMultipleFlowsSelected="setAreMultipleFlowsSelected"
          @unSelectAll="unSelectAll"
        />
        <div class="white-space"></div>
      </div>
      <div class="accordion" role="tablist" v-if="!isShowTableView">
        <b-card
          no-body
          class="mb-1 accordion-main-wrapper"
          v-for="(group, index) in getGroupedProcessList"
          :key="group.id"
          v-if="group.resources.length > 0"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              class="accordion-button"
              block
              v-b-toggle="`accordion-${group.id}`"
              variant="info"
              @click="toggleAccordion(`accordion-${group.id}`)"
              ><span :class="{ 'last-item': group.id == 'ungroup-flows' }">
                {{ group.name }}
              </span>
            </b-button>
          </b-card-header>
          <b-collapse
            :id="`accordion-${group.id}`"
            role="tabpanel"
            :visible="expandedAccordionId.includes(`accordion-${group.id}`)"
            @hide="toggleAccordion(`accordion-${group.id}`, true)"
          >
            <div class="group-process-list-wrapper">
              <div class="process-list-wrapper">
                <WorkFlowListCard
                  v-for="p in group.resources"
                  :key="p.id"
                  :process="p"
                  :selectedFlows="selectedFlows"
                  :addTag="addTag"
                  :showLoadingOverlay="showLoadingOverlay"
                  :copyEmbedModal="copyEmbedModal"
                  :resourceType="resourceType"
                  :confirmationModal="confirmationModal"
                  :isShareModalVisible="isShareModalVisible"
                  :flowRequest="flowRequest"
                  :selectedFlow="selectedFlow"
                  :filter="filter"
                  :selectionMsg="selectionMsg"
                  @setSelectedFlow="setSelectedFlow"
                  @setResourceType="setResourceType"
                  @setIsLoading="setIsLoading"
                  @setShareFlowModal="setShareFlowModal"
                  @onFlowSelect="onFlowSelect"
                  @setAreMultipleFlowsSelected="setAreMultipleFlowsSelected"
                  @unSelectAll="unSelectAll"
                />
              </div>
            </div>
          </b-collapse>
          <div class="divider"></div>
        </b-card>
      </div>
    </div>
    <div
      class="loading process-list-item-loader"
      :style="getProcessListItemLoaderStyle"
      v-show="getIsListLoading"
    >
      <div class="progress-icon dark-color"></div>
    </div>
    <div
      class="group-actions"
      :class="{ disabled: showLoadingOverlay.length }"
      v-show="selectedFlows.length > 0"
    >
      <div class="inner">
        <p>
          <span class="selected-items">{{ selectedFlows.length }}</span>
          <span class="selected-items-label">Ausgewählte Einträge</span>
        </p>
        <ul
          v-if="filter != 'requests'"
          class="toolbar"
          :class="{ disabled: isFlowOwnerPermission.length }"
        >
          <li
            class="item share"
            v-b-tooltip.hover
            title="Teilen"
            @click="shareSelectedFlows()"
          >
            <a class="link">share</a>
          </li>
          <li
            class="item download"
            v-b-tooltip.hover
            title="Herunterladen"
            @click="downloadSelectedFlows()"
          >
            <a class="link">download</a>
          </li>
          <li
            class="item delete"
            v-b-tooltip.hover
            title="Löschen"
            @click="deleteSelectedFlows()"
          >
            <a class="link">delete</a>
          </li>
        </ul>
        <ul v-else class="requests toolbar">
          <li class="item" @click="onMultipleFlowAction('accepted')">
            Annehmen
          </li>
          <li class="item" @click="onMultipleFlowAction('rejected')">
            Ablehnen
          </li>
        </ul>
      </div>
      <div class="select-all-wrapper">
        <button
          class="btn-select-all"
          @click="selectAll()"
          :disabled="areAllFlowsSelected"
        >
          Alle auswählen
        </button>
        <button class="btn-select-all" @click="unSelectAll()">
          Alle abwählen
        </button>
      </div>
    </div>
    <htmlViewer
      v-if="htmlViewerModal.isHtmlViewerVisible"
      @close="closeHtmlViewer"
      :myHtml="htmlViewerModal.myHtml"
    ></htmlViewer>
    <ShareFlowModal
      v-if="isShareModalVisible && !areMultipleFlowsSelected"
      @close="closeFlowModal"
      :flowId="Number(selectedFlow.id)"
    ></ShareFlowModal>
    <ShareFlowModal
      v-if="isShareModalVisible && areMultipleFlowsSelected"
      :flows="selectedFlows"
      customClass="share-multiple-flows"
      @close="closeShareMultipleFlowsModal"
    ></ShareFlowModal>
    <removeConfirmationModal
      v-if="
        confirmationModal.isRemoveConfirmationVisible &&
        !areMultipleFlowsSelected
      "
      @close="closeRemoveConfirmationModal"
      :id="selectedFlow.id"
      :name="selectedFlow.name"
      :actionType="confirmationModal.actionType"
      :resourceType="resourceType"
      @confirmRemove="removeFlow"
      @confirmLeave="leaveFlow"
    ></removeConfirmationModal>
    <removeConfirmationModal
      v-if="
        confirmationModal.isRemoveConfirmationVisible &&
        areMultipleFlowsSelected
      "
      @close="closeRemoveConfirmationModal"
      :flows="selectedFlows"
      :name="confirmationModal.name"
      :actionType="confirmationModal.actionType"
      :resourceType="confirmationModal.resourceType"
      @confirmRemove="removeMultipleFlows"
    ></removeConfirmationModal>
    <modal-box
      class="modal-window"
      v-bind:title="modalBox.title"
      v-bind:message="modalBox.msg"
      v-bind:buttonCaption="modalBox.btnCaption"
      v-if="isModalBoxVisible"
      @close="hideModalBox"
    />
    <AddGroupModal
      :tagList="getFlowTagList"
      v-if="isAddGroupModalIsOpen"
      :groups="groups"
      @addGroup="addGroup"
      @closeModal="isAddGroupModalIsOpen = !isAddGroupModalIsOpen"
    ></AddGroupModal>
  </div>
</template>

<script>
import htmlViewer from '../components/modals/htmlViewer.vue';
import ShareFlowModal from '../components/modals/ShareFlowModal.vue';
import removeConfirmationModal from '../components/modals/removeConfirmModal.vue';
import { schema } from '../models/VueModels';
import ModalBox from '../components/modals/ModalBox.vue';
import NoFlows from '../components/NoFlows.vue';
import workFlowDataSchema from '../assets/data-schemas/workFlowDataSchema.json';
import AddGroupModal from '../components/modals/AddGroupModal.vue';
import { workFlowAccessLevel } from '../enum/auth.enum';
import { mapActions, mapGetters } from 'vuex';
import GeneralDropdown from '../components/core/general-dropdown.vue';
import {
  getWorkFlowById,
  deleteWorkflowById,
} from '../services/workflow.service';
import { getFlowLastId, debouncer, jsonParser } from '../utils/helpers';
import CopyEmbedModal from '../components/modals/CopyEmbedModal.vue';

import CommonModal from '@/components/modals/CommonModal.vue';
import { updatePolicy } from '@/services/axios/data.api';
import LoadingSpinner from '../components/widgets/LoadingSpinner.vue';
import WorkFlowListCard from '../components/WorkFlow/WorkFlowListCard.vue';
import ShareMultipleFlowsModal from '../components/modals/shareMultipleFlowsModal.vue';

export default {
  name: 'ProcessListPage',
  data() {
    return {
      workFlowAccessLevel: workFlowAccessLevel,
      embedCodeCopied: '',
      lastID: null,
      showLoadingOverlay: [],
      isSortActive: true,
      modalBox: {
        showAfterQueueIsDone: false,
        title: '',
        msg: [],
        btnCaption: 'Schliessen',
      },
      isModalBoxVisible: false,
      zoom: 70,
      htmlViewerModal: {
        isHtmlViewerVisible: false,
        myHtml: null,
      },
      confirmationModal: {
        actionType: null,
        isRemoveConfirmationVisible: false,
      },
      isCreateFlowOptionsVisible: false,
      requestError: null,
      isRefreshing: false,
      showMore: false,
      showActionsDropdown: false,
      searchActive: false,
      search: '',
      isUploadFileVisible: false,
      isAddFilterVisible: false,
      filters: [],
      activeFilter: null,
      isClickOutsideDelayed: true,
      isEditFilterVisible: false,
      operatorOption: [
        {
          label: 'beinhaltet',
          opperand: '.includes(',
          visibility: 'all',
        },
        {
          label: 'beinhaltet nicht',
          opperand: '!.includes(',
          visibility: 'all',
        },
        {
          label: 'ist genau',
          opperand: '==',
          visibility: 'all',
        },
        {
          label: 'ist nicht',
          opperand: '!=',
          visibility: 'all',
        },
        {
          label: 'ist grösser',
          opperand: '>',
          visibility: 'number',
        },
        {
          label: 'ist grösser oder gleich',
          opperand: '>=',
          visibility: 'number',
        },
        {
          label: 'ist kleiner',
          opperand: '<',
          visibility: 'number',
        },
        {
          label: 'ist kleiner oder gleich',
          opperand: '<=',
          visibility: 'number',
        },
      ],
      selectedFlows: [],
      selectedFlow: null,
      resourceType: null,
      isGroupFlowListOpen: false,
      groups: [],
      isLoading: true,
      isGroupOpen: '',
      isAddGroupModalIsOpen: false,
      tagModalOpenId: '',
      copyEmbedModal: {
        visible: false,
        loading: false,
        selectedFlow: {},
        elements: [],
      },
      filterOptions: {
        unset: {
          caption: 'Alle',
        },
        myOwn: {
          caption: 'Meine',
        },
        sharedWithMe: {
          caption: 'Geteilt',
        },
        requests: {
          caption: 'Anfragen',
        },
      },
      filter: 'unset',
      flowRequestActions: [
        {
          text: 'Bestätigen',
          action: 'onConfirmFlowRequest',
          loading: false,
        },
        {
          text: 'Abbrechen',
          action: 'onCancelCancelFlowRequest',
          loading: false,
        },
      ],
      flowRequest: {
        isVisibleFlowConfirmation: false,
        flowConfirmationMessage: null,
        requestStatus: null,
        flowId: [],
      },
      addTag: {
        searchTag: '',
        selectedTag: [],
        tempTags: [],
        tagColorsList: [
          '#E0C5FF',
          '#EEFBF0',
          '#FFF4E4',
          '#EAF8FE',
          '#FBEEEE',
          '#FFDFDF',
          '#FFFEEF',
          '#F1FAFD',
        ],
        isListOpen: false,
        isNewTag: false,
        isColorsListOpen: false,
        isTagLoading: false,
        isTagVisible: true,
        isTagModalVisible: false,
      },
      tagDisplayOnModel: [],
      isCardHoverIndex: null,
      lastSelectedFlowForShiftSelect: null,
      isShareModalVisible: false,
      isFlowOwnerPermission: [],
      expandedAccordionId: [],
      areMultipleFlowsSelected: false,
      accordionIds: [],
      isFileDragging: false,
      selectionMsg: {
        single: {
          accept: 'Dieser Workflow wird Ihrem Konto hinzugefügt',
          reject:
            'Dieser Workflow wird vollständig von Ihrem Konto entfernt, Sie werden nicht in der Lage sein, darauf zuzugreifen',
        },
        multiple: {
          accept: 'Diese Workflows werden Ihrem Konto hinzugefügt',
          reject:
            'Diese Workflows werden vollständig von Ihrem Konto entfernt, Sie werden nicht in der Lage sein, darauf zuzugreifen.',
        },
      },
    };
  },
  methods: {
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    hideSearch() {
      if (this.search.trim() === '') {
        this.$refs.search.blur();
        this.search = '';
        this.searchActive = false;
      }
    },
    closeCopyEmbedModal() {
      this.copyEmbedModal.visible = false;
      this.copyEmbedModal.selectedFlow = {};
      this.copyEmbedModal.elements = [];
      this.copyEmbedModal.loading = false;
    },
    ...mapActions({
      removeSingleFlowById: 'removeSingleFlowByIdAction',
    }),
    addGroup(data) {
      this.groups.push(data);
    },
    newID() {
      return getFlowLastId(this);
    },
    checkFlowMatchesModel(flowModel, importedFlow) {
      const validKeys = Object.keys(flowModel);
      const receivedKeys = Object.keys(importedFlow);
      return (
        validKeys.length === receivedKeys.length &&
        validKeys.every((value) => ~receivedKeys.indexOf(value))
      );
    },

    getImgUrl(img) {
      var images = require.context('../assets/img/', false, /\.png$/);
      return images(img);
    },

    async createNewFlow() {
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: this.newID(),
        type: 'app',
      });

      if (rslt == 'Access Token has expired') {
        localStorage.clear(),
          this.$router.push({
            name: 'auth',
            params: { message: 'Sitzung abgelaufen' },
          });
      } else this.goToProcess(rslt);
    },
    async getFlow(id) {
      const response = await getWorkFlowById(id);
      if (response && response.status === 200) {
        return response.data;
      }
    },

    async goToProcess(id) {
      this.$router.push({
        path: '/',
        query: {
          section: 'process-designer',
          process: id,
        },
      });
    },

    toggleFileUploader() {
      this.$refs.uploadBtn.click();
    },

    toggleCreateFlowOptions() {
      this.isCreateFlowOptionsVisible = !this.isCreateFlowOptionsVisible;
    },

    toggleUploadFile() {
      this.isUploadFileVisible = !this.isUploadFileVisible;
    },

    hideModalBox() {
      this.isModalBoxVisible = false;
    },

    hideFileUploader() {
      this.isUploadFileVisible = false;
    },
    importFlow() {
      this.toggleCreateFlowOptions();
      this.toggleUploadFile();
      this.isLoading = true;

      // Get file from input
      let file = this.$refs.uploadBtn.files[0];

      var reader = new FileReader();
      // Function to read file values
      var self = this;
      reader.onload = function () {
        var importedProcess = JSON.parse(reader.result);

        // Assign current ID to import
        importedProcess.id = self.newID();
        importedProcess.owner = self.user.username;

        // Check if import matches flow-model
        let flowModels = [
          schema.models.FlowV1,
          schema.models.FlowV2,
          schema.models.FlowV3,
          schema.models.FlowV4,
          schema.models.FlowV5,
        ];

        var flowMatchesModel = false;

        for (let f of flowModels) {
          let match = self.checkFlowMatchesModel(f, importedProcess);
          if (match == true) {
            flowMatchesModel = true;
            break;
          }
        }
        if (flowMatchesModel) self.saveProcess(importedProcess, true);
        else {
          self.modalBox.msg = [];
          // Display error modal
          self.$set(self.modalBox, 'showAfterQueueIsDone', false);
          self.$set(
            self.modalBox.msg,
            self.modalBox.msg.length,
            'Der importierte Flow entspricht nicht dem Schema.'
          );
          self.isLoading = false;
          self.isModalBoxVisible = true;
        }
      };
      this.isUploadFileVisible = false;
      reader.readAsText(file);
    },
    saveProcess(flow, redirect) {
      this.$store
        .dispatch('saveFlow', {
          flow: flow,
        })
        .then((message) => {
          // Success always returns the ID as number
          if (typeof message == 'number') return message;
          else throw new Error(message);
        })
        .then((id) => {
          if (redirect) {
            this.isLoading = false;
            this.goToProcess(id);
          }
        })
        .catch((e) => {
          this.requestError = e;
        });
    },
    async removeFlow(id) {
      try {
        this.showLoadingOverlay.push(id);

        const filteredFlowsList = this.ProcessList.filter(
          (flow) => flow.id != id
        );
        const deleteWorkflowResponse = await deleteWorkflowById(id);

        if (deleteWorkflowResponse.status == 200) {
          await this.$store.commit('addFlow', filteredFlowsList);
        }
        this.showLoadingOverlay.splice(this.showLoadingOverlay.indexOf(id), 1);
        this.selectedFlows = this.selectedFlows.filter((flow) => flow.id != id);
      } catch (error) {
        this.showLoadingOverlay.splice(this.showLoadingOverlay.indexOf(id), 1);
        this.showToaster('etwas ist schief gelaufen', 'Fehler', 'danger');
      }
    },
    async leaveFlow(id) {
      const url = `${process.env.VUE_APP_DATA_API}/flow/iam/${id}`;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      const response = await fetch(url, {
        headers: myHeaders,
        method: 'DELETE',
      });
      const responseJson = await response.json();
      if (responseJson.ResponseMetadata.HTTPStatusCode == 200) {
        this.removeSingleFlowById(id);
        this.showLoadingOverlay.splice(this.showLoadingOverlay.indexOf(id), 1);
      }
    },
    async updateFlow(id, name) {
      let flow = await this.getFlow(id);
      flow.name = name;
      this.saveProcess(flow, false);
    },
    closeHtmlViewer() {
      this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', false);
    },
    closeFlowModal() {
      this.isShareModalVisible = false;
    },
    setShareFlowModal(value) {
      this.isShareModalVisible = true;
    },
    closeRemoveConfirmationModal() {
      this.confirmationModal.isRemoveConfirmationVisible = false;
    },
    // set focus on input (search)
    toggleSearch() {
      this.searchActive = !this.searchActive;
      if (this.searchActive) {
        this.$refs.search.focus();
      } else {
        this.search = '';
      }
    },
    saveFiltersInLocalStorage() {
      localStorage.setItem(
        `workflowFilters-${this.user.username}`,
        JSON.stringify(this.filters)
      );
    },
    hideAddFilter() {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        this.isAddFilterVisible = false;
        this.activeFilter = null;
      }
      this.saveFiltersInLocalStorage();
    },
    showAddFilter() {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        this.isAddFilterVisible = false;
        this.activeFilter = null;
        return null;
      }
      const activeFilterData = {
        id: this.newID(),
        caption: null,
        property: null,
        opperand: null,
        value: null,
      };
      this.activeFilter = activeFilterData;
      this.isAddFilterVisible = true;
      this.$set(this.filters, this.filters.length, activeFilterData);
    },
    addFilterCaption(propertyName) {
      this.activeFilter.property = propertyName;
      this.dataSchema.forEach((data) => {
        if (data.name == propertyName) {
          this.activeFilter.caption = data.label;
          this.activeFilter.type = data.type;
          this.activeFilter.options = data.options;
          this.activeFilter.value = data.value;
        }
      });
      this.$forceUpdate();
    },
    showEditFilter(filter) {
      this.activeFilter = filter;
      this.isClickOutsideDelayed = true;
      this.isEditFilterVisible = true;
      setTimeout(() => (this.isClickOutsideDelayed = false), 300);
    },
    hideEditFilter() {
      if (this.isEditFilterVisible && !this.isClickOutsideDelayed) {
        this.isEditFilterVisible = false;
        this.activeFilter = null;
      }
    },
    removeFilter(id) {
      this.filters = this.filters.filter((filter) => filter.id != id);
      this.saveFiltersInLocalStorage();
    },
    removeEmptyFilter() {
      this.filters = this.filters.filter((filter) => filter.property != null);
    },
    formatLabel(l) {
      if (l.length > 25) return l.slice(0, 25) + '...';
      else return l;
    },
    async refreshTable() {
      this.isRefreshing = true;
      this.unSelectAll();
      await this.$store.dispatch('getFlows');
      await this.$store.dispatch('fetchWorkFlowTags');
      this.isRefreshing = false;
    },
    onCardCheck(flow) {
      if (this.selectedFlows.includes(flow.id) && this.selectedFlows.length) {
        this.selectedFlows.splice(
          this.selectedFlows.indexOf((e) => e.id === flow.id),
          1
        );
      } else {
        this.selectedFlows.push(flow);
      }
    },
    toggleMore() {
      this.showMore = !this.showMore;
    },
    toggleActionsDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },
    addFilterOpperand(opperand, label) {
      this.activeFilter.opperand = opperand;
      this.activeFilter.opperandLabel = label;
      this.$forceUpdate();
    },
    addFilterValue(val, name) {
      this.activeFilter.value = val;
      this.activeFilter.valueName = name;
    },
    showFilterOperator(operator) {
      return (
        operator.visibility === 'all' ||
        (operator.visibility === 'number' &&
          this.activeFilter.type === 'number')
      );
    },
    setFilter(filter) {
      const filters = Object.keys(this.filterOptions).filter(
        (el) => el != 'requests'
      );

      if (
        (this.filter == 'requests' && filters.includes(filter)) ||
        (filters.includes(this.filter) && filter == 'requests')
      ) {
        this.selectedFlows = [];
      }
      this.filter = filter;
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    getFilterValue(filter) {
      if (filter.property == 'tags') {
        return filter.value.map((el) => el.name).join(', ');
      }
      return Array.isArray(filter.value)
        ? filter.value.join(', ')
        : filter.value;
    },
    getFilterItemStyles(filterItem) {
      if (filterItem.property == 'tags') {
        const tag = filterItem.options.find(
          (el) => el?.value == filterItem?.value
        );

        if (tag?.meta?.color) {
          return {
            backgroundColor: tag.meta.color,
            borderColor: tag.meta.color,
          };
        }
      }

      return {};
    },
    removeSelectedRadioOrCheckboxOption(index) {
      this.activeFilter.value.splice(index, 1);
    },
    closeDropDown(refID) {
      if (this.$refs[refID]) {
        if (Array.isArray(this.$refs[refID])) {
          this.$refs[refID][0].hideDropdown(refID);
        } else {
          this.$refs[refID].hideDropdown(refID);
        }
      }
    },
    onMultipleFlowAction(actionType) {
      if (this.selectedFlows.length > 0) {
        const msgType = this.selectedFlows.length === 1 ? 'single' : 'multiple';
        const msg =
          actionType == 'accepted'
            ? this.selectionMsg[msgType].accept
            : this.selectionMsg[msgType].reject;
        this.flowRequest = {
          isVisibleFlowConfirmation: true,
          requestStatus: actionType,
          flowConfirmationMessage: msg,
          flowId: this.selectedFlows.map((el) => el.policy_id),
        };
      }
    },
    async onConfirmFlowRequest() {
      try {
        this.flowRequestActions[0].loading = true;
        await Promise.all(
          this.flowRequest.flowId.map((el) =>
            updatePolicy(el, {
              status: this.flowRequest.requestStatus,
            })
          )
        );
        this.flowRequestActions[0].loading = false;
        this.flowRequest.isVisibleFlowConfirmation = false;
        await this.refreshTable();
        if (!this.processFlowRequestList.length) {
          this.setFilter('unset');
        }
      } catch (error) {
        this.showToaster(
          `Fluss konnte nicht ${
            this.flowRequest.requestStatus === 'accepted'
              ? 'akzeptiert'
              : 'abgelehnt'
          } werden`,
          'Fehler',
          'danger'
        );
      } finally {
        this.onCancelCancelFlowRequest();
        this.flowRequestActions[0].loading = false;
      }
    },
    onCancelCancelFlowRequest() {
      this.flowRequest = {
        isVisibleFlowConfirmation: false,
        flowConfirmationMessage: null,
        requestStatus: null,
        flowId: [],
      };
    },
    setSelectedFlow(value) {
      this.selectedFlow = value;
    },
    setResourceType(value) {
      this.resourceType = value;
    },
    setIsLoading(bool) {
      this.isLoading = bool;
    },
    toggleGroupView() {
      this.isGroupFlowListOpen = !this.isGroupFlowListOpen;
      localStorage.setItem(
        `isGrouped-${this.user.username}`,
        this.isGroupFlowListOpen
      );
      if (!this.isGroupFlowListOpen) {
        this.expandedAccordionId =
          jsonParser(
            localStorage.getItem(`isAccordionOpen-${this.user.username}`)
          ) || [];
      }
    },
    toggleAccordion(id = null, hide = false) {
      if (!hide && id) {
        this.accordionIds.push(id);
        localStorage.setItem(
          `isAccordionOpen-${this.user.username}`,
          JSON.stringify(this.accordionIds)
        );
      } else {
        this.accordionIds = this.accordionIds.filter(
          (accordionid) => id !== accordionid
        );
        localStorage.setItem(
          `isAccordionOpen-${this.user.username}`,
          JSON.stringify(this.accordionIds)
        );
      }
    },
    onFlowSelect(event, flow) {
      const currentSelectedFlowIndex = this.sortedProcessList.findIndex(
        (process) =>
          process == this.lastSelectedFlowForShiftSelect &&
          this.selectedFlows.includes(process)
      );

      if (
        event.shiftKey &&
        currentSelectedFlowIndex != -1 &&
        !this.selectedFlows.includes(flow)
      ) {
        this.selectAllFlowsBetweenShiftPressed(currentSelectedFlowIndex, flow);
      } else {
        this.toggleSeletedFlow(flow);

        this.lastSelectedFlowForShiftSelect = flow;
      }

      if (
        this.filter != 'requests' &&
        (flow.access_level == workFlowAccessLevel.EXECUTE ||
          flow.access_level == workFlowAccessLevel.EDIT_CONTENT)
      ) {
        if (event.target.checked) {
          this.isFlowOwnerPermission.push(flow);
          this.showToaster(
            'Mindestens einer der ausgewählten Workflows verfügt über eingeschränkte Berechtigungen. Es werden nur Vorgänge für den Workflow mit den geringsten Berechtigungen angezeigt.',
            'Hinweis',
            'warning'
          );
        } else {
          this.isFlowOwnerPermission.splice(
            this.isFlowOwnerPermission.indexOf(flow),
            1
          );
        }
      }
    },
    selectAllFlowsBetweenShiftPressed(currentSelectedFlowIndex, flow) {
      const newFlowSelectionIndex = this.sortedProcessList.findIndex(
        (process) => process == flow
      );

      currentSelectedFlowIndex < newFlowSelectionIndex
        ? this.selectFilterFlowsInCustomRange(
            currentSelectedFlowIndex,
            newFlowSelectionIndex
          )
        : this.selectFilterFlowsInCustomRange(
            newFlowSelectionIndex,
            currentSelectedFlowIndex
          );
    },
    selectFilterFlowsInCustomRange(startingIndex, endingIndex) {
      this.sortedProcessList.forEach((process, index) =>
        index >= startingIndex && index <= endingIndex
          ? this.selectFlow(process)
          : ''
      );
    },
    selectFlow(flow) {
      if (!this.selectedFlows.includes(flow)) this.selectedFlows.push(flow);
    },
    toggleSeletedFlow(flow) {
      const index = this.selectedFlows.findIndex(
        (selectedId) => selectedId == flow
      );
      if (index > -1) {
        this.selectedFlows.splice(index, 1);
        if (this.selectedFlows.length < 1) {
          this.areMultipleFlowsSelected = false;
        }
      } else {
        this.selectedFlows.push(flow);
      }
    },
    selectAll() {
      this.selectedFlows = this.sortedProcessList.filter((process) => {
        return process;
      });

      if (this.filter != 'requests') {
        this.isFlowOwnerPermission = this.selectedFlows.filter((flow) => {
          if (
            flow.access_level == workFlowAccessLevel.EXECUTE ||
            flow.access_level == workFlowAccessLevel.EDIT_CONTENT
          ) {
            return process;
          }
        });

        if (this.isFlowOwnerPermission.length) {
          this.showToaster(
            'Mindestens einer der ausgewählten Workflows verfügt über eingeschränkte Berechtigungen. Es werden nur Vorgänge für den Workflow mit den geringsten Berechtigungen angezeigt.',
            'Hinweis',
            'warning'
          );
        }
      }
    },
    unSelectAll() {
      this.selectedFlows = [];
      this.isFlowOwnerPermission = [];
    },
    deleteSelectedFlows() {
      this.areMultipleFlowsSelected = true;
      this.confirmationModal = {
        name: 'Mehrere Workflows löschen',
        isRemoveConfirmationVisible: true,
        isMultipleItems: true,
        itemsCount: this.selectedFlows.length,
        actionType: 'remove',
        resourceType: 'flow',
      };
    },
    async removeMultipleFlows(flows) {
      try {
        await Promise.allSettled(
          flows.map(async (flow) => {
            this.showLoadingOverlay.push(flow.id);
            return await deleteWorkflowById(flow.id);
          })
        );

        const filteredFlowsList = this.ProcessList.filter(
          (process) => !this.showLoadingOverlay.includes(process.id)
        );

        this.$store.commit('addFlow', filteredFlowsList);
        this.selectedFlows = [];
      } catch (error) {
        this.showToaster('etwas ist schief gelaufen', 'Fehler', 'danger');
      } finally {
        this.showLoadingOverlay = [];
      }
    },
    shareSelectedFlows() {
      this.areMultipleFlowsSelected = true;
      this.isShareModalVisible = true;
    },
    closeShareMultipleFlowsModal() {
      this.isShareModalVisible = false;
    },
    async downloadSelectedFlows() {
      try {
        const responses = await Promise.allSettled(
          this.selectedFlows.map(async (flow) => {
            this.showLoadingOverlay.push(flow.id);
            return await this.getFlow(flow.id);
          })
        );
        const vm = this;
        responses.forEach((val) => {
          if (val.status === 'fulfilled') {
            // Copy and reset owner & tableID
            var deepCopy = Object.assign(
              {},
              JSON.parse(JSON.stringify(val.value))
            );
            deepCopy.id = getFlowLastId(vm);
            deepCopy.owner = '';

            // TODO: Delete if there are no more old flows
            if (deepCopy.hasOwnProperty('tableID')) deepCopy.tableID = '';
            else deepCopy['tableID'] = '';

            // Remove input & output
            deepCopy.tasks.forEach((part, index, arr) => {
              arr[index].output = [];
              arr[index].input = [];
            });

            // Create data string & export
            const dataStr =
              'data:text/json;charset=utf-8,' +
              encodeURIComponent(JSON.stringify(deepCopy));
            const link = document.createElement('a');
            link.setAttribute('href', dataStr);
            link.setAttribute('download', deepCopy.name + '.json');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      } catch (error) {
        this.showToaster(error.msg, 'Fehler', 'danger');
      } finally {
        this.showLoadingOverlay = [];
      }
    },
    setAreMultipleFlowsSelected(val) {
      this.areMultipleFlowsSelected = val;
    },
    initializeFromLocalStorage() {
      const isGrouped = localStorage.getItem(`isGrouped-${this.user.username}`);
      this.isGroupFlowListOpen =
        isGrouped && isGrouped === 'true' ? true : false;

      const openAccordionId =
        localStorage.getItem(`isAccordionOpen-${this.user.username}`) || [];
      this.expandedAccordionId = jsonParser(openAccordionId) || [];
      this.accordionIds = jsonParser(openAccordionId) || [];

      this.filters =
        jsonParser(
          localStorage.getItem(`workflowFilters-${this.user.username}`)
        ) || [];
    },
    handleFileDrop(e) {
      this.isFileDragging = false;
      this.$refs.uploadBtn.files = e.dataTransfer.files;
      this.importFlow();
    },
  },
  created() {
    // Delay to prevent "no item screen" before rendering item
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);

    this.initializeFromLocalStorage();
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId',
      getWorkflowsPerTag: 'getWorkflowsPerTag',
      getTagsPerWorkflow: 'getTagsPerWorkflow',
      getFlowsLoading: 'getFlowsLoading',
    }),
    user() {
      return this.$store.state.user;
    },
    hasAddNewFlowPermission() {
      return this.$store.state.addNewFlowPermission && !this.isPreviewSection;
    },
    noData() {
      return this.ProcessList.length < 1;
    },
    getOperatorOption() {
      if (this.activeFilter) {
        if (this.activeFilter.property == 'tags') {
          const visibleOperators = ['ist genau', 'ist nicht'];
          return this.operatorOption.filter((el) =>
            visibleOperators.includes(el.label)
          );
        }
      }

      return this.operatorOption;
    },
    getTagOptions() {
      return (
        this.getWorkflowsPerTag.map((el) => ({
          name: el.name,
          value: el.id,
          meta: el,
        })) || []
      );
    },
    dataSchema() {
      const tagFilter = {
        name: 'tags',
        label: 'tags',
        type: 'checkbox',
        value: [],
        options: this.getTagOptions,
      };

      if (this.getWorkflowsPerTag?.length > 0 && this.addTag.isTagVisible) {
        return [...workFlowDataSchema, tagFilter];
      }
      return workFlowDataSchema;
    },
    isZoomVisible() {
      return !this.isLoading;
    },
    ProcessList() {
      return this.$store.state.flows;
    },
    customFilteredProcessList() {
      const filterItems = this.ProcessList;
      if (this.filters.length <= 0 || this.isPreviewSection) return filterItems;
      else {
        // Get only filters that can be interpreted
        let readyFilters = [];
        for (let filter of this.filters) {
          if (filter.property && filter.value && filter.opperand) {
            readyFilters.push(filter);
          }
        }
        if (readyFilters.length > 0) {
          let filterString = '';
          for (let f of readyFilters) {
            const filterValue =
              f.value.includes('"') && f.value.includes("'")
                ? '`' + `${f.value}` + '`'
                : f.value.includes('"')
                ? `'${f.value}'`
                : `"${f.value}"`;
            // Simple type filter
            if (f.opperand == '==' || f.opperand == '!=') {
              if (
                f.property == 'tags' &&
                f.value &&
                Array.isArray(f.value) &&
                f.value.length > 0
              ) {
                const filterIDs = f.value.map((el) => el.value);
                const filteredTags = this.getWorkflowsPerTag.filter((el) =>
                  filterIDs.includes(el.id)
                );
                const opperand = f.opperand == '!=' ? '!' : '';

                if (filteredTags?.length) {
                  const finalResources = filteredTags
                    .map((el) => el.resources)
                    .flat();
                  filterString += `${opperand}${JSON.stringify(
                    finalResources
                  )}.includes(e.id) && `;
                }
              } else {
                filterString += `String(e.${f.property}).toLowerCase()${f.opperand} ${filterValue}.toLowerCase() && `;
              }
              // filter vor Numbers
            } else if (
              f.opperand == '<' ||
              f.opperand == '<=' ||
              f.opperand == '>' ||
              f.opperand == '>='
            ) {
              filterString += `e.${f.property} ${f.opperand} ${filterValue} && `;
            } else if (f.opperand == '!.includes(') {
              filterString += `!String(e.${f.property}).toLowerCase().includes((${filterValue}).toLowerCase()) && `;
            } else {
              filterString += `String(e.${f.property}).toLowerCase()${f.opperand}${filterValue}.toLowerCase()) &&`;
            }
          }
          filterString = filterString.slice(0, filterString.length - 3);
          // eslint-disable-next-line no-unused-vars
          return filterItems.filter((e) => eval(filterString));
        } else return filterItems;
      }
    },
    sortedProcessList() {
      try {
        this.isLoading = true;
        let flowList = this.customFilteredProcessList;
        if (this.isPreviewSection) {
          flowList = this.filterPendingFlows.filter(
            (flow) => flow.type !== 'action'
          );
        } else if (this.filter === 'myOwn') {
          flowList = flowList.filter((list) => list.access_level === 'owner');
        } else if (this.filter === 'sharedWithMe') {
          flowList = this.processFlowSharedList;
        } else if (this.filter === 'requests') {
          flowList = this.processFlowRequestList;
        } else if (this.filter === 'unset') {
          flowList = this.filterPendingFlows;
        }

        if (this.search !== '') {
          return flowList.filter((i) => {
            return (
              (i.hasOwnProperty('name') &&
                i.name.toLowerCase().includes(this.search.toLowerCase())) ||
              (i.hasOwnProperty('id') && String(i.id).includes(this.search))
            );
          });
        } else if (this.isSortActive) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          return flowList.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          return flowList;
        }
      } finally {
        this.isLoading = false;
      }
    },
    getGroupedProcessList() {
      const groupedList = this.getWorkflowsPerTag.map((flow) => {
        return {
          ...flow,
          resources: flow.resources
            .map((id) => {
              const matchFlow = this.sortedProcessList.find(
                (item) => item.id == id
              );
              return matchFlow ? matchFlow : null;
            })
            .filter(Boolean),
        };
      });

      const unTagGroup = this.sortedProcessList.filter(
        (flow) => !Object.keys(this.getTagsPerWorkflow).includes(flow.id)
      );

      return [
        ...groupedList,
        {
          id: 'ungroup-flows',
          name: 'Ohne Tags',
          resources: [...unTagGroup],
        },
      ];
    },
    processFlowRequestList() {
      return this.customFilteredProcessList.filter(
        (list) => list.policyStatus === 'pending'
      );
    },
    processFlowSharedList() {
      return this.customFilteredProcessList.filter(
        (list) =>
          (list.access_level === 'execute' ||
            list.access_level === 'edit' ||
            list.access_level === 'edit-content') &&
          list.policyStatus !== 'pending'
      );
    },
    filterPendingFlows() {
      return this.customFilteredProcessList.filter(
        (list) => list.policyStatus !== 'pending'
      );
    },
    getFlowTagList() {
      return this.getWorkflowsPerTag.length
        ? this.getWorkflowsPerTag.map((el) => ({
            id: el.id,
            tagName: el.name,
            tagColor: el.color,
            resources: el.resources,
          }))
        : [];
    },
    getActiveFilterOption() {
      if (this.activeFilter.caption) {
        if (this.activeFilter.property == 'tags') {
          return this.getTagOptions;
        }
        return this.activeFilter.options;
      }
      return [];
    },
    showFilter() {
      if (this.filters.length === 1 && this.filters[0].caption === null) {
        return false;
      }
      return true;
    },
    getProcessListItemLoaderStyle() {
      return {
        top: `calc(140px + 36px  ${
          this.hasAddNewFlowPermission ? ' +  130px' : ''
        })`,
        height: `calc(100% - 140px - 36px ${
          this.hasAddNewFlowPermission ? '- 130px' : ''
        })`,
      };
    },
    getIsListLoading() {
      return this.isLoading || this.getFlowsLoading || this.isRefreshing;
    },
    areAllFlowsSelected() {
      return this.selectedFlows.length == this.sortedProcessList.length;
    },
    isPreviewSection() {
      return this.$route.query.section === 'preview';
    },
    isShowTableView() {
      return (
        !this.isLoading && (!this.isGroupFlowListOpen || this.isPreviewSection)
      );
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          const dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    htmlViewer,
    ShareFlowModal,
    removeConfirmationModal,
    ModalBox,
    NoFlows,
    AddGroupModal,
    GeneralDropdown,
    CopyEmbedModal,
    CommonModal,
    LoadingSpinner,
    WorkFlowListCard,
    ShareMultipleFlowsModal,
  },
};
</script>
<style scoped>
.wrapper {
  height: 100%;
}

.process-list {
  background-color: #fff;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: scroll;
  width: 100%;
  height: calc(78vh - 170px);
  /* scrollbar-width: thin; */
}

.process-list .accordion .collapse {
  margin-top: 0px;
}

.process-list .accordion .card-header:has(.not-collapsed) img {
  transform: rotate(180deg);
}

.process-list.full-height {
  height: calc(94vh - 155px);
}
.item-wrapper:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 70%);
  opacity: 0;
  visibility: hidden;
  border-radius: 0 0 12px 12px;
  transition: all 300ms ease-in-out;
}

.show-overlay:before {
  opacity: 1;
  visibility: visible;
}

.item-wrapper {
  width: 466px;
  background: #fff;
  margin: 0 40px 40px 0;
  -webkit-box-shadow: 0 1px 2px rgb(43 59 93 / 29%);
  box-shadow: 0 1px 2px rgb(43 59 93 / 29%);
  /* cursor: pointer; */
  border-radius: 12px;
  transition: box-shadow 0.2s ease, transform 0.2s ease,
    -webkit-box-shadow 0.2s ease, -webkit-transform 0.2s ease;
  text-align: left;
  zoom: 0.7;
  padding: 25px;
  position: relative;
  border: 1px solid #ebecee;
}

.item-wrapper:hover {
  box-shadow: 0px 12px 24px 0px rgb(0 0 0 / 20%);
  top: -4px;
  border-color: #fff;
}

.item-wrapper .flow-title {
  color: #424956;
  font-size: 30px;
  font-weight: 300;
  text-align: left;
  width: 100%;
  line-height: 45px;
  margin: 0;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.process-list-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-top: 45px;
  flex-wrap: wrap;
  padding: 10px;
}

.img-wrapper {
  width: 100%;
  height: 172px;
}

.logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

p {
  margin: 0 30px;
}

.round-button-wrapper {
  width: 200px;
  display: block;
  margin-left: 85%;
  position: absolute;
  height: 60px;
  z-index: 6;
}

.round-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: rgb(255, 51, 102);
  height: 60px;
  text-align: center;
  width: 60px;
  line-height: 59px;
  font-size: 30px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  position: absolute;
  top: -33px;
}

.round-button img {
  width: 30px;
}

.round-button-wrapper.clicked .round-button {
  transform: rotate(45deg);
}

.round-button:hover {
  transform: scale(1.1) rotate(0);
}

.round-button-wrapper.clicked .round-button:hover {
  transform: scale(1.1) rotate(45deg);
}

.plus-btn-options {
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  background-color: #ffff;
  bottom: unset;
  margin-top: 50px;
  margin-bottom: unset;
  margin-right: 32px;
  margin-left: -331px;
}

.plus-btn-options.no-shadow {
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: transparent;
  margin-left: 0;
  margin-top: 30px;
}

.plus-btn-options .option {
  text-align: center;
  display: inline-block;
  padding: 47px 15px 45px;
  border-right: solid 1px #dbdee5;
  cursor: pointer;
  width: 165px;
}

.plus-btn-options .option h2 {
  font: 600 15px/22px brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  color: #434c5e;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
}

.plus-btn-options .icon {
  font-size: 65px;
}

.data-dz-thumbnail-bg-overlay:hover {
  opacity: 1;
}

.data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 172px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

a.btn,
.policy-request-buton.btn {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  letter-spacing: 1px;
  line-height: 44px;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  text-decoration: none;
  left: 0;
  right: 0;
  position: unset !important;
  top: 65px;
  width: fit-content;
  height: 47px;
  color: black;
  border: 1px solid #bdbfc5;
  border-radius: 5px;
  margin: 0;
  text-transform: none;
  font-size: 21px;
  font-weight: 300;
  padding: 0 18px 0px;
  display: inline-block;
  margin-right: 5px;
}

a.btn.edit-process {
  top: 70px;
}

a.btn:hover,
.policy-request-buton.btn:hover {
  background-color: rgb(39 39 42 / 5%);
}

.tools li.delete a {
  background-position: -129px -759px;
}

/*
.tools li.duplicate a {
  background-image: url("../assets/img/codelos-icons.svg");
  background-size: 32px 20px;
  background-position: -18px -3px;
}
*/
.tools li.leave a {
  background-image: url('../assets/img/codelos-icons.svg');
  background-size: 32px 20px;
  background-position: -1px -3px;
}

.tools li img {
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
  padding: 6px;
  border-radius: 5px;
  width: 36px;
}

.tools li i {
  color: #505050;
  font-size: 20px;
  font-weight: 600;
  top: 2.4px;
  position: relative;
  padding: 6px;
}

.tools li img:hover,
.tools li i:hover {
  background-color: rgb(39 39 42 / 5%);
}

.tools {
  position: unset;
  right: 17px;
  top: 7px;
  z-index: 2;
  border: 0px solid transparent;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
  margin-top: 0;
  width: fit-content;
  height: 29px;
  margin-bottom: 0;
  float: right;
}

.tools li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.tools a {
  text-indent: -9999px;
}

.tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: unset;
  background-size: unset;
  background-position: unset;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.tools li > a:hover {
  opacity: 1;
}

.tools li.share a {
  background-position: -868px -268px;
}

.tools li.download a {
  background-position: -868px -646px;
}

.tools li.iam i {
  color: rgb(194, 194, 194);
  font-size: 15px;
}

.tools li.delete a {
  background-position: -129px -759px;
}

.progress-icon {
  display: block;
  position: relative;
  left: auto;
  top: 108px;
  width: 70px;
  height: 70px;
}

.progress-icon {
  left: 152px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}

.progress-icon.dark-color:after {
  border-color: #1f2532 transparent #1f2532 transparent;
  width: 100px;
  height: 100px;
  top: -25%;
  position: absolute;
  left: -23%;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* .loading .progress-icon {
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  bottom: unset;
} */

.zoom {
  width: 170px;
  position: relative;
  margin: unset;
  padding: unset;
  top: unset;
  bottom: unset;
  margin-top: 60px;
  margin-left: 73%;
}

.slider {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  height: 2px;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.toolbar .share .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: 0 -759px;
}

.option.round {
  border-radius: 50%;
  display: block;
  border: none;
  width: 60px;
  height: 60px;
  padding: 0;
  font-size: 18px;
  line-height: 60px;
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  background: #ffff;
  margin-top: 14px;
  color: #1f2532;
}

:v-deep .tooltip {
  top: 0;
  left: -500px;
  right: 600px;
  bottom: 0;
}

.content {
  margin: 0px 30px;
  -webkit-box-flex: 1;
  flex: 1;
  padding-top: 55px;
  padding-bottom: 55px;
  min-height: 264px;
}

.scrollable {
  min-height: 100%;
}

.header {
  width: 100%;
  height: 35px;
}

.footer {
  height: 52px;
}

.white-space {
  width: 100%;
  height: 0px;
  display: grid;
}
/* .custom-loader.show {
  opacity: 1 !important;
} */
.custom-loader {
  height: 100%;
  z-index: 1;
  opacity: 1 !important;
}
.data-dz-thumbnail-bg-overlay.custom-loader:hover {
  opacity: 0;
}

.custom-loader .progress-icon {
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  height: auto;
}
.process-list-container
  .data-dz-thumbnail-bg-overlay.custom-loader
  .progress-icon {
  left: 0 !important;
}

.custom-loader + .header {
  position: relative;
  z-index: 2;
}

.process-list-topbar {
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.process-list-topbar .multi-edit-btn {
  margin: 0 !important;
  cursor: pointer;
}

.menu3-bar .list-item {
  padding-left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.menu3-bar .list-item > li {
  text-align: -webkit-match-parent;
  margin: 0 26px 0 0;
  vertical-align: top;
  display: inline-block;
  cursor: pointer;
}

.menu3-bar .list-item > li.item-mode-toggle {
  /* margin-top: 40px; */
  font-size: 23px;
  color: #646f81;
}
.menu3-bar .list-item > li.add-folder {
  margin-top: 41px;
  font-size: 21px;
  color: #646f81;
}
.settings-button-wrapper {
  position: relative;
  display: block;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
}

.settings-button-wrapper img {
  width: 20px;
}

.settings-button-wrapper > div {
  padding: 0.375rem 0.75rem;
  box-sizing: border-box;
  cursor: pointer;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}
.refresh.rotation img {
  animation: rotation 1.5s infinite linear;
}

.refresh {
  padding-top: 7px;
  transition: all 0.2s ease-in-out;
}

.refresh:hover {
  transform: scale(1.1) rotate(0);
}

.checker span {
  background-image: url(../assets/img/project-sprite.png);
  background-size: 882px 840px;
  background-position: -710px -316px;
  height: 31px;
  width: 30px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}

.checker span.checked {
  background-position: -398px -283px;
  position: relative;
  top: 8px;
}

.checker {
  display: inline-block;
}
.checked.item-wrapper {
  box-shadow: 0 0 0 2px #1fc281;
}

/*bottom bar*/
.group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
  position: relative;
  top: 30%;
}

.group-actions .toolbar {
  margin: 3px 0 0 -179px;
  position: absolute;
  left: 50%;
  padding: 0;
}

.group-actions .toolbar .share .link {
  background-image: url(http://localhost:8080/img/project-sprite.1c2e7465.png);
  background-position: 0 -759px;
}

.group-actions .toolbar .link {
  cursor: pointer;
  top: 50%;
  display: block;
  text-indent: -9999px;
  opacity: 0.9;
  background-size: 882px 840px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: block;
  overflow: hidden;
}

.group-actions .toolbar li {
  float: left;
  margin: 0 15px;
  list-style: none;
  padding: 0;
  text-align: -webkit-match-parent;
}

.group-actions .inner .requests.toolbar .item {
  cursor: pointer;
}

.select-all-wrapper {
  float: right;
  margin-right: 100px;
  margin-top: 0;
  top: 30%;
  position: relative;
}

.btn-select-all {
  background-color: white;
  border-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  font-size: 16px;
  margin-left: 12.5px;
}

.group-actions .toolbar li.download .link {
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}

.group-actions .toolbar .dropdown .link {
  background-position: -463px -759px;
  width: 18px;
  height: 4px;
  top: 8px;
}

.toolbar .more .toggle-list-wrapper.toggle-up {
  margin-top: -100%;
  padding: 20px 0px 20px 0px;
  min-width: 195px;
  left: 0;
  top: 0;
}

.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item {
  background: #fff;
  line-height: 36px;
  width: 100%;
  margin: 0;
  padding: 0 19px;
  margin-left: 7px;
  font-size: 14px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item:hover {
  background-color: #f0f0f0;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item.more {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA4AAAAAhCAYAAACInMWBAAAAAXNSR0IArs4c6QAAAFBlWElmTU0AKgAAAAgAAgESAAMAAAABAAEAAIdpAAQAAAABAAAAJgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAADgKADAAQAAAABAAAAIQAAAAD9kkEtAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAAGJElEQVR4Ae3cv4scVRwA8Jm9O+tgnUoQK7n2yhTiP5B/QATbBIscgiksgkiCSIKdIOlSxT9ALK5MJ8FGEayEdCGQztzt+L6bnSOZzLz9wczbLT4Lw86+737f93ufXebusXuvqtwIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQI7ItAvU0jP/z8+INZU31WN83Hkd/U9R/zunr45efX/1lnvl3nr9Oj54wn0DTN1TTb3XRcW856lu5P67r+d/k4e7fr/GxzgqMLPHny9Gq6ntyt6ubaYvKmPkvXm9OTk+Ps+6V03ug/uAnXEojrwatX87t1/fp60jTV2dHRbOX1pHTeWj+MJ40ucOPW7Q+b84Pvqrr6ZDF5U/1WH1589eDenb9zxUrn5XoRm07gwU+Pr746n6e/R5a/X6r67Ohwdnrji+vZ3y+l86YTMHNOoPTrvG293M+wbmzjBWAs3g7mzb2mrt57s0jdVP9dzOpbqxaBu85/s2fn0wssF29PU6X3O9Wep8fHqxaBu87v9OzhxAKxiGtmVe/7pZ5Xx0OLwNJ5EzOYfkAgrgfn5/On6f6t60m6jjw/PJwNXk9K5w20b3higZs3b380Pzh4kspc6ZR6Mbu4OLl//85fnfHFw9J5fT0Ym17g9R/bF73Xj6PDg+OhRWDpvOklVOgTKP06b1uvr/dtxmabJsUnf93FX8wRYxFbNd+u81f1Jz66QHzy99Yfa8sKMRaxVbdd56/qT3xEgcUnfwPvl2Wst1rpvN4mDE4uEJ/8dRd/UTTGIjbUQOm8oT6MTyswnx18myp0F39R9Moy1ttA6bzeJgxOLhCf/A1ePxafCva3UDqvvwujUwuUfp23rTeWw8YLwPZrn30N5GLt83PPycXGym/ncV9M4FqmUi7WpuWek4uNld/O476EQPu1z75a+xTr68/Y5ALt1z77Cu1TrK8/YwUE2q999pWqq0/7hhdjpfMGGxGYVqD92mdflX2K9fVnbHqBfXoP5HoZR2LjBeA4Zc1CgAABAgQIECBAgAABAqUFNl4AxoYvQ03mYm1O7jm52Fj57TzuiwmcZSrlYm1a7jm52Fj57TzuSwikDV8Gy+xTbLBJgSkFYsOXofn3KTbUo/GJBdKGL4MVmurXTKxs3mAjAtMKZH6/pM1ghmuXjg13IjKlQOnXedt64xhsvABM/2vzMDZ86ZaPsYh1x7uPd53f7cfjyQVOU4XY8KV7i7GIrbrtOn9Vf+IjCsRun2m63vfLMtZbrXRebxMGJxdY7vb5zvsjNoGJ2FADpfOG+jA+rUAzq79OFV70VHmxjPWE0v+QFs7rbcLg5AKx22dcK7qFFtePFOuOt49L57V13ZcVKP06b1tvLJWNF4Cxy2fs9llV9e9p0XceR5yvswNoNL3r/LHgzLOeQLqwxtbKx+l4lI5nyyPOB3fsS7HL267zLxtxUkQgdvmM3T7TpzmPmqp5tjjSeW4H0GisdF4RDEXeEYjrQez2mX7nPErnz+KI89wOoDFJ6bx3GjdQRODH77/5M3b7rJrql/Sqv1wc6TzGIjbUROm8oT6MTysQu3zGbp91Pbu8fsR5bgfQ6Kh03rQKZh8SKP06b1tvqH/jBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEClwL/A0RbxXDyZfAlAAAAAElFTkSuQmCC);
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.toggle-list-wrapper.toggle-up.toggle-right {
  position: absolute;
  left: 230px !important;
  margin-top: -100%;
  padding: 20px 0px 20px 0px;
  min-width: 195px;
}
.group-actions .toolbar li.item.more .toggle-right {
  font-size: 20px;
}

/*Search Input */
.search {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  cursor: auto;
  height: 37px;
}

.search img {
  width: 22px;
}

.filter-icon img {
  width: 20px;
}

.search-icon {
  cursor: pointer;
  padding-bottom: 2px;
}

.search input {
  border: 0;
  width: 0;
  margin-left: 5px;
  margin-top: 8px;
  cursor: initial;
  font-size: 14px;
  margin: 6px;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  height: 100%;
  background: transparent;
  -webkit-transition: width 0.3s ease, border-color 0.3s ease;
  transition: width 0.3s ease, border-color 0.3s ease;
  outline: none;
  box-sizing: border-box;
  margin: 0;
  text-indent: 6px;
  padding: 0;
}

.search.active {
  position: relative;
}

.search.active:before {
  content: '';
  position: absolute;
  border-bottom: solid 2px rgb(255, 51, 102);
  width: 100%;
  bottom: 0;
}

.search.active input {
  width: 230px;
}

.add-new-button-wrapper {
  position: relative;
  height: 140px;
  z-index: 1;
  width: 100%;
}

.add-new-button {
  text-align: center;
  display: block;
  cursor: pointer;
  color: white;
  border-radius: 6px;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 114px;
  line-height: 59px;
  font-size: 23px;
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  position: unset;
  top: 15px;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  float: right;
  margin-top: 45px;
  font-family: 'AktivGroteskMedium';
}

.add-new-button i {
  color: white;
  font-size: 18px;
  opacity: 0.5;
  padding: 5px;
  padding-right: 0px;
  border: none;
}

.add-new-button i:hover {
  opacity: 1;
}

.add-new-button:hover {
  -webkit-transform: scale(1.1) rotate(0);
  transform: scale(1.1) rotate(0);
}
.add-new-button-wrapper .dropdown-list-open {
  position: absolute;
  right: 0;
  top: 115px;
  border-radius: 4px;
  z-index: 10;
  text-align: center;
  cursor: pointer;
}

.process-list-container .filter-list-main-wrap {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.filter-item-wrapper {
  display: flex;
  vertical-align: top;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
}

.filter-item-wrapper .filter-item {
  font-size: 13px;
  border: solid 1px #cdcdcd;
  width: fit-content;
  min-width: 20px;
  border-radius: 6px;
  display: inline-block;
  color: #58647d;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
}

.filter-item span {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.filter-item i {
  width: 0;
  opacity: 0;
  position: relative;
}

.filter-item:hover {
  background-color: #f5f5f5;
}

.filter-item:hover .tag__wrapper i {
  width: 13px;
  opacity: 1;
  font-size: 13px;
  margin-left: 8px;
  color: #b5b5b5;
}

.filter-item i.fa-caret-down {
  font-size: 15px;
  opacity: 1;
  width: 10px;
  margin-left: 16px;
}

.filter-item:hover i:hover {
  color: black;
}

.filter-item-wrapper .filter-item .filter.dropdown.edit {
  position: fixed;
  display: block;
  margin-top: 140px;
  margin-left: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 12px;
}

.filter-item-wrapper
  .filter-item
  .filter.dropdown.edit
  ::v-deep
  .dropdown
  .btn {
  width: 200px;
}

/* .filter-item-wrapper .filter-item .filter.dropdown.edit input {
  border: 1px solid #9398a3;
  margin-left: 10px;
  margin-right: 10px;
  height: 26px;
  padding: 1px;
} */

.item.filter-option.show-option {
  padding-bottom: 40px;
}

.key-filter select:focus {
  outline-width: 0;
}

.key-filter input:focus {
  outline-width: 0;
}

.key-filter .filter .tools i {
  font-size: 15px !important;
}

.filter.dropdown select,
input {
  border: none;
  display: inline-block;
  height: 36px;
  width: 119px;
  color: #000;
  font-size: 14px;
  text-align: center;
  padding: 6px 12px;
}

.filter.dropdown.edit select,
input {
  display: block;
  border-radius: 3px;
  text-align: left;
}

.filter.dropdown.add {
  top: 40px;
}
.filter.dropdown.add select,
input {
  display: inline-block;
}

.filter.dropdown.upload {
  width: 290px !important;
  padding: 39px !important;
  font-size: 14px !important;
  color: #4a556a !important;
  font-family: sans-serif !important;
  cursor: pointer !important;
  position: relative !important;
  margin-left: 0 !important;
  background-color: white !important;
  border: none !important;
  display: block !important;
  box-shadow: 0 0 15px -2px rgb(0 0 0 / 25%);
  z-index: 15;
  text-align: center !important;
}
.process-list-container .filter.dropdown.upload.drag-over {
  position: relative;
}

.process-list-container .filter.dropdown.upload.drag-over:before {
  content: '';
  position: absolute;
  left: 5px;
  top: 5px;
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  border: 1px dashed gray;
  background-color: #cdd8ee57;
  border-radius: 8px;
}

.process-list-container .filter.dropdown {
  background-color: white;
  -webkit-box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  box-shadow: 0 0 15px -2px rgb(0 0 0 / 25%);
  border-radius: 6px;
  position: absolute;
  z-index: 15;
  margin-left: 0;
  border: 1px solid #cdcdcd;
  padding: 12px 12px;
  display: flex;
}

.process-list-container .filter ::v-deep .dropdown-item {
  color: #58647d;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  border-radius: 3px;
  padding: 5px 10px;
  white-space: normal;
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.process-list-container .filter ::v-deep li {
  list-style: none;
  padding: 0 7px;
}
.process-list-container .filter ::v-deep ul {
  padding: 7px 0;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.25);
  border: 1px solid #c0c0c0;
}
.process-list-container .filter ::v-deep li:hover {
  background-color: #ececec;
  border-radius: 5px;
}

.process-list-container .filter.dropdown.is-key-selected {
  padding: 32px 12px;
}

.process-list-container .filter-dropdown ::v-deep .customDropdown {
  border: 1px solid #cdcdcd;
  border-radius: 6px;
  justify-content: center;
  width: auto;
  min-width: 120px;
}
.process-list-container .filter-dropdown ::v-deep .customDropdown:hover {
  background: #cdcdcd !important;
}

.process-list-container .filter-dropdown ::v-deep .customDropdown .line-clamp {
  color: #58647d;
  margin-right: 8px;
  font-size: 13px;
  width: calc(100% - 20px);
}
.process-list-container
  .filter-dropdown
  ::v-deep
  .customDropdown
  .dropdown-toggle-icon {
  padding: 0 0 0 0;
}

.process-list-container .filter-margin-right {
  margin-right: 24px !important;
}

.process-list-container .filter-margin-left {
  margin-left: 24px !important;
}

.process-list-container .filter-input {
  border-radius: 6px;
  border: 1px solid #cdcdcd;
  margin: 0;
  height: 35px !important;
  min-width: 135px;
  font-size: 13px;
  color: #58647d;
  padding: 6px 12px;
  text-align: left;
  width: 119px;
}

.filter.dropdown hr {
  margin-top: 3px;
  background-color: #f0ebeb;
}

.filter.dropdown h2 {
  font-weight: 300;
  font-size: 22px;
  margin-bottom: 26px;
}

.filter.dropdown select {
  background: white;
}

/*for centered loader*/
.process-list {
  position: relative;
}

.progress-icon.dark-color.center:after {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
}
.progress-icon.dark-color {
  left: 0;
  margin: 0 auto;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  border-radius: 9px;
  margin-top: 5px;
  box-sizing: border-box;
  padding: 20px;
  z-index: 3;
  cursor: pointer;
}
.group-list {
  display: block;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.group-list > span {
  display: block;
  padding: 8px 20px;
  background: #dfdfdf;
  border-radius: 4px;
  cursor: pointer;
}
.group-list.open > span i {
  transform: rotate(90deg);
}

.group-list > span i {
  margin-right: 20px;
  font-size: 16px;
  transition: all 300ms ease-in-out;
}
.group-list-wrapper {
  flex-wrap: wrap;
  padding: 15px;
  border: 1px solid #eee;
  display: none;
}
.group-list.open .group-list-wrapper {
  display: flex;
}
.add-new-button-wrapper .dropdown-list-open.unset-zIndex {
  z-index: 0;
}
p.message {
  position: absolute;
  right: 0;
  left: -10px;
  top: 35px;
  margin: 0 auto;
  display: block;
  color: green;
  font-size: 18px;
}

.embed {
  position: relative;
}
.action-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  min-height: 30px;
}

.action-top-bar,
.add-new-button-wrapper {
  padding: 0px 10px;
}

.process-list-wrapper .code-tag-icon {
  zoom: 1.2;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}

.process-list-container .no-data {
  display: block;
  width: 500px;
  max-width: 100%;
  position: relative;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.process-list-container .dz-no-content-message {
  width: 100%;
  text-align: center;
  color: #6b7482;
  font-weight: 300;
}

.process-list-container .dz-no-content-message img.no-data {
  position: inherit;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  width: 278px;
}
.process-list-container .dz-no-content-message img.no-data.create-workflow {
  cursor: pointer;
}
.process-list-container .menu3-bar .item {
  border-bottom: solid 2px transparent;
}
.process-list-container .menu3-bar .item.active {
  border-bottom: solid 2px rgb(255, 51, 102);
  color: rgb(247 58 105);
}
.process-list-container .item .pending-request {
  margin-left: 10px;
  background-color: red;
  border-radius: 30px;
  padding: 4px;
  color: #fff;
  font-size: 10px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
}
.process-list-container .menu3-bar .list-item li {
  display: flex;
  align-items: center;
}
.action-top-bar .list-item .item a {
  line-height: 21px;
}

.process-list-container .filter.dropdown .initial-dropdown-items li {
  padding: 0;
}

.process-list-container .filter-dropdown .tag-item ::v-deep .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.process-list-container .filter-dropdown .tag-item .tag-color-block {
  width: 10px;
  height: 10px;
  border-radius: 50px;
}

.process-list-container .worflow-tag-list-wrapper {
  position: relative;
}

.process-list-container .workflow-tag-list {
  display: flex;
  gap: 8px;
  font-size: 22px;
  align-items: center;
  flex-wrap: wrap;
}

.process-list-container .workflow-tag-list .workflow-tag {
  padding: 10px 15px;
  border-radius: 12px;
  color: black;
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
}

.process-list-container
  .filter-dropdown
  ::v-deep
  .dropdown-item
  .custom-control-input {
  width: 16px;
  accent-color: #ff3366;
}

.process-list-container
  .filter-dropdown
  ::v-deep
  .dropdown-item
  .custom-checkbox {
  display: flex;
  padding: 0 10px 0 0;
  align-items: center;
  width: 100%;
  max-width: 100%;
  gap: 10px;
}

.process-list-container
  .checkbox-dropdown::v-deep
  .custom-checkbox
  .custom-control-label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  max-width: 100%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  cursor: pointer !important;
}

.process-list-container
  .checkbox-dropdown::v-deep
  .custom-checkbox
  .custom-control-label
  .tag-option-name {
  padding: 3px 7px;
  border-radius: 3px;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.process-list-container .checkbox-dropdown .tag-item {
  padding: 0 10px !important;
}

.process-list-container .checkbox-dropdown ::v-deep .custom-checkbox {
  width: 100%;
  max-width: 100%;
  padding: 0 10px !important;
}

.process-list-container .show .selected-filter-checkbox-options-wrap {
  visibility: hidden;
}

.process-list-container .selected-filter-checkbox-options-wrap {
  width: calc(100% - 20px);
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.process-list-container
  .checkbox-dropdown
  .dropdown-item
  ::v-deep
  .custom-checkbox:hover {
  background-color: #f0f0f0 !important;
  color: #212529 !important;
  border-radius: 4px !important;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.process-list-container .checkbox-dropdown ::v-deep .tag-item:hover {
  background-color: transparent !important;
}
.process-list-container .selected-filter-checkbox-item {
  display: inline-block;
  padding: 2px 7px;
  background: #ececec;
  margin-right: 4px;
  color: #58647d;
  font-size: 13px;
  line-height: normal;
  border-radius: 3px;
}

.process-list-container
  .selected-filter-options-wrap
  ::v-deep
  .selected-filter-options {
  border-radius: 3px;
  padding: 2px 6px;
  color: #58647d;
  font-size: 13px;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 6px;
}

.process-list-container ::v-deep .checkbox-dropdown .close-dropdown-icon {
  opacity: 1;
  font-size: 13px;
  margin-left: auto;
  color: #b5b5b5;
  position: absolute;
  right: 18px;
  top: 15px;
}

.process-list-container ::v-deep .show.checkbox-dropdown .customDropdown {
  border: none !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.process-list-container .selected-filter-options ::v-deep span {
  max-width: 100px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.process-list-container .checkbox-dropdown ::v-deep .selected-filter-options i {
  color: #a6a6a6;
  font-size: 12px;
  margin-left: 5px;
  display: inline-block;
  opacity: 1;
  width: auto;
}
.process-list-container
  .dropdown.edit
  .selected-filter-options-wrap
  ::v-deep
  .close-dropdown-icon {
  position: absolute;
  right: 30px;
  top: 15px;
}
.process-list-container .checkbox-dropdown ::v-deep ul {
  padding: 5px;
  width: 220px;
  border-radius: 6px;
  box-shadow: 0.2px 0.2px 5px rgba(0, 0, 0, 0.2);
  border: none !important;
  margin-top: -33px !important;
}

::v-deep .filter .checkbox-dropdown {
  width: 220px;
  max-width: 100%;
}

.process-list-container .selected-filter-options-wrap {
  padding: 6px;
  border: 1px solid #cdcdcd;
  border-radius: 6px;
  -webkit-box-shadow: 0.2px 0.2px 5px rgba(0, 0, 0, 0.2);
  box-shadow: 0.2px 0.2px 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

/* Accordion Style */

.accordion .accordion-main-wrapper {
  border: none !important;
}

.accordion .accordion-main-wrapper .card-header {
  display: flex;
  align-items: center;
  padding: 0 !important;
}

.accordion .accordion-main-wrapper .card-header,
.accordion .accordion-main-wrapper .card-header .btn {
  border: none !important;
  background-color: transparent !important;
  text-align: left !important;
}

.accordion .accordion-main-wrapper .card-header .btn span {
  text-transform: capitalize;
  margin-right: 50px;
  display: inline-block;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.94px;
  color: #333343;
  text-wrap: nowrap;
}

.accordion .accordion-main-wrapper .last-item {
  text-wrap: nowrap !important;
  font-weight: 700 !important;
}

.accordion .accordion-main-wrapper .divider {
  border-bottom: 1px solid #bfc8da;
  width: 100%;
  opacity: 0.5;
}

.accordion .accordion-main-wrapper .card-header .chevron-down-svg {
  margin-left: 3px;
  opacity: 0.4;
}

.accordion-button::after {
  background-image: url(../assets/img/chevron-down.svg) !important;
  opacity: 0.3;
  margin-top: 0px;
  background-size: 12px;
  width: 12px !important;
  height: 12px !important;
}

.accordion-button {
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 12px;
  align-items: center;
}
.accordion-button:focus {
  box-shadow: none;
}
.accordion-button:not(.collapsed) {
  color: inherit;
  box-shadow: none;
}

.btn-check:checked + .btn:focus-visible,
:not(.btn-check) + .btn:active:focus-visible,
.btn:first-child:active:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible {
  box-shadow: none;
}

.accordion-main-wrapper .group-process-list-wrapper .process-list-wrapper {
  margin: 0;
  padding: 20px;
}

.process-list-container
  .checkbox-dropdown
  .custom-checkbox
  .custom-control-label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  max-width: 100%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  cursor: pointer !important;
}

.process-list-container .process-list-item-loader {
  background-color: #fff;
}

.process-list-container .confirm-message-wrapper {
  max-width: 400px;
  margin-bottom: 24px;
}

.process-list-container .confirm-message {
  color: #212529;
  font-size: 16px;
  margin: 0;
  text-align: center;
}
.process-list-container .group-actions.disabled {
  pointer-events: none;
  cursor: not-allowed;
}
.process-list-container .group-actions.disabled .inner .toolbar,
.process-list-container .group-actions.disabled .select-all-wrapper {
  opacity: 0.5;
}
.process-list-container .group-actions {
  display: block;
  background: #fff;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -1px 0 rgba(76, 86, 103, 0.2),
    0 -2px 35px rgba(31, 37, 50, 0.14);
  z-index: 1001;
  left: 0;
  width: 100%;
  height: 76px;
  padding: 10px 35px;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  text-align: center;
  float: left;
  clear: both;
}

.process-list-container .group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
}

.process-list-container .group-actions .toolbar {
  margin: 3.8px 0 0 -179px;
  position: absolute;
  left: 50%;
}

.process-list-container .group-actions .toolbar.disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}

.process-list-container .group-actions .selected-items {
  font-size: 11px;
  border-radius: 100px;
  background: #0fbf00;
  color: #fff;
  padding: 1px 14px 0px;
  margin: 1px 6px 0 0;
  float: left;
  font-weight: 600;
}
.process-list-container .group-actions .selected-items-label {
  float: left;
  font-size: 12px;
  color: #4a556b;
  font-weight: 600;
  text-transform: uppercase;
  float: left;
  margin: 2px 0 0 10px;
  text-rendering: optimizelegibility;
}

.process-list-container .group-actions .toolbar .delete .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -868px 0;
  width: 14px;
  height: 18px;
}

.process-list-container .group-actions .toolbar .download .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}
.process-list-container .disable-scroll {
  overflow: hidden;
}
.preview-process-list-container .process-list {
  height: calc(78vh - 30px);
}
.preview-process-list-container .process-list-wrapper {
  justify-content: center;
  gap: 40px;
}

.preview-process-list-container .menu3-bar .list-item li {
  margin: 0;
}

.preview-process-list-container .action-top-bar {
  gap: 20px;
}

.preview-process-list-container .search.active ::v-deep input {
  width: calc(100% - 30px);
  max-width: 100%;
}
.preview-process-list-container .menu3-bar .list-item {
  justify-content: start;
}
.preview-process-list-container .settings-button-wrapper {
  padding: 0 !important;
}
.preview-process-list-container ::v-deep .work-flow-card-wrapper .card .footer {
  text-align: center;
}

.preview-process-list-container ::v-deep .item-wrapper {
  margin: 0;
}
/* media query */

@media (max-width: 767px) {
  .tooltip.b-tooltip {
    left: -50px !important;
  }

  .preview-process-list-container .no-data {
    width: 100%;
    max-width: 100%;
  }
  .preview-process-list-container .action-top-bar .action-top-bar-left {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 380px) {
  .preview-process-list-container ::v-deep .item-wrapper {
    width: 100%;
    max-width: 100%;
  }
  .preview-process-list-container .work-flow-card-wrapper {
    width: 100%;
    max-width: 100%;
  }
}
</style>
